import { render, staticRenderFns } from "./InvoiceDetailsModal.vue?vue&type=template&id=3944bb10&"
import script from "./InvoiceDetailsModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports